import React from "react";
import { Link } from "react-router-dom";

function BoardMembers() {
  return (
    <>
      {/* Breadcrumb Section */}
      <div className="innerslide py-3 bg-light border-bottom">
        <ul className="breadcrumb container mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>

          <li className="breadcrumb-item active">Board Members</li>
        </ul>
      </div>

      {/* Main Content Section */}
      <section className="boardmembers-section">
        <div className="container">
          <h2 className="boardmembers-title text-center mb-5">Board Members</h2>

          <div className="row g-4">
            {/* Card 1 */}
            <div className="col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="boardmember-card">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/David_Hilton.jpg"
                  alt="Mr. David J. Hilton"
                  className="img-fluid boardmember-image"
                />
                <h5 className="mt-3 text-center boardmember-name">
                  Mr. David J. Hilton
                </h5>
                <p className="boardmember-designation text-center">
                  President/Chairman
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="boardmember-card">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Charmaine_Fanthome.JPG"
                  alt="Mrs. Charmaine Fanthome Beecham"
                  className="img-fluid boardmember-image"
                />
                <h5 className="mt-3 text-center boardmember-name">
                  Mrs. Charmaine Fanthome Beecham
                </h5>
                <p className="boardmember-designation text-center">
                  Vice-President
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="boardmember-card">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Patricia_Hilton.jpg"
                  alt="Mrs. Patricia Mary Hilton"
                  className="img-fluid boardmember-image"
                />
                <h5 className="mt-3 text-center boardmember-name">
                  Mrs. Patricia Mary Hilton
                </h5>
                <p className="boardmember-designation text-center">
                  Vice-President
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="boardmember-card">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/dummy_person.jpg"
                  alt="Mr. Lancelot J. Fuller"
                  className="img-fluid boardmember-image"
                />
                <h5 className="mt-3 text-center boardmember-name">
                  Mr. Lancelot J. Fuller
                </h5>
                <p className="boardmember-designation text-center">
                  Honorary Secretary
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="boardmember-card">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/dummy_person.jpg"
                  alt="Mr.H.E.Wilkins"
                  className="img-fluid boardmember-image"
                />
                <h5 className="mt-3 text-center boardmember-name">
                  Mr. H. E. Wilkins
                </h5>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="boardmember-card">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/dummy_person.jpg"
                  alt="Miss Margaretta Eastwood "
                  className="img-fluid boardmember-image"
                />
                <h5 className="mt-3 text-center boardmember-name">
                  Miss Margaretta Eastwood
                </h5>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="boardmember-card">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/KIm_Noble.JPG"
                  alt="Mr. Kim Noble "
                  className="img-fluid boardmember-image"
                />
                <h5 className="mt-3 text-center boardmember-name">
                  Mr. Kim Noble
                </h5>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="boardmember-card">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Albert_Temple.JPG"
                  alt="Mr. Albert Temple  "
                  className="img-fluid boardmember-image"
                />
                <h5 className="mt-3 text-center boardmember-name">
                  Mr. Albert Temple
                </h5>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="boardmember-card">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Ashok_Chadha.JPG"
                  alt="Mr. Albert Temple  "
                  className="img-fluid boardmember-image"
                />
                <h5 className="mt-3 text-center boardmember-name">
                  Mr. Ashok Chadha
                </h5>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="boardmember-card">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Kevin_Pope.JPG"
                  alt="Mr. Kevin D. Pope "
                  className="img-fluid boardmember-image"
                />
                <h5 className="mt-3 text-center boardmember-name">
                  Mr. Kevin D. Pope
                </h5>
                <p className="boardmember-designation text-center">
                  Principal
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="boardmember-card">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Jean_Ireland.JPG"
                  alt="Miss Jean Elizabeth Andrea Ireland "
                  className="img-fluid boardmember-image"
                />
                <h5 className="mt-3 text-center boardmember-name">
                  Miss Jean Elizabeth Andrea Ireland
                </h5>
                <p className="boardmember-designation text-center">
                  Headmistress
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default BoardMembers;
